import React from 'react';
import './styles.scss';
import { ENUM_TRANSACTION_ACTION } from 'models/transaction.model';

const TransactionTag = ({ type }: { type: ENUM_TRANSACTION_ACTION }) => {
  return (
    <div
      className={`transaction-tag ${type === ENUM_TRANSACTION_ACTION.CREDIT ? 'credit' : 'debit'}`}>
      <p className='dot'> </p>
      <p>{type === ENUM_TRANSACTION_ACTION.CREDIT ? 'credit' : 'debit'}</p>
    </div>
  );
};

export default TransactionTag;
